import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import InstallerLayout from '../components/InstallerLayout';
import api from '../api/axios';
import { C } from '../theme';

export default function InstallerDashboard() {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get('/api/installer/stats').then(r => setStats(r.data)).catch(() => {});
  }, []);

  const cards = [
    { label: "Dispatched Today", val: stats?.today ?? '—', color: '#8B5CF6', bg: '#F3E8FF', icon: '📦' },
    { label: "Total Dispatched",  val: stats?.total ?? '—', color: C.primary, bg: C.primaryLight, icon: '🚀' },
  ];

  return (
    <InstallerLayout title="Dashboard">

      {/* Welcome */}
      <div style={{
        background: `linear-gradient(135deg, ${C.sidebar} 0%, #2A1A05 100%)`,
        borderRadius: '16px', padding: '28px 32px', marginBottom: '24px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <div>
          <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)', marginBottom: '4px' }}>Welcome back,</div>
          <div style={{ fontSize: '22px', fontWeight: 800, color: C.primary }}>{stats?.name || '…'}</div>
          <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.35)', marginTop: '4px' }}>Installer — HIVE ERP</div>
        </div>
        <div style={{ fontSize: '52px', opacity: 0.6 }}>🐝</div>
      </div>

      {/* Stat cards */}
      <div style={{ display: 'flex', gap: '16px', marginBottom: '24px', flexWrap: 'wrap' }}>
        {cards.map(c => (
          <div key={c.label} style={{
            flex: '1 1 160px', background: C.white,
            border: `1px solid ${C.border}`, borderRadius: '12px',
            padding: '20px 22px', display: 'flex', alignItems: 'center', gap: '14px',
          }}>
            <div style={{ width: '44px', height: '44px', borderRadius: '10px', background: c.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', flexShrink: 0 }}>
              {c.icon}
            </div>
            <div>
              <div style={{ fontSize: '26px', fontWeight: 800, color: c.color }}>{c.val}</div>
              <div style={{ fontSize: '11px', color: C.textSub, fontWeight: 500 }}>{c.label}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Quick action */}
      <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: '16px', padding: '32px', textAlign: 'center' }}>
        <div style={{ fontSize: '48px', marginBottom: '12px' }}>📷</div>
        <div style={{ fontSize: '18px', fontWeight: 700, color: C.textMain, marginBottom: '6px' }}>Scan & Dispatch a Package</div>
        <div style={{ fontSize: '13px', color: C.textSub, marginBottom: '24px', lineHeight: 1.6 }}>
          Open the camera, point it at the barcode printed on the package,<br />
          and the system will dispatch it automatically.
        </div>
        <button
          onClick={() => navigate('/installer/get-device')}
          style={{
            padding: '14px 36px',
            background: `linear-gradient(135deg, #8B5CF6, #6D28D9)`,
            color: '#fff', border: 'none', borderRadius: '10px',
            fontSize: '14px', fontWeight: 700, cursor: 'pointer',
            boxShadow: '0 4px 16px rgba(109,40,217,0.35)',
          }}
        >
          📷 Open Get Device
        </button>
      </div>
    </InstallerLayout>
  );
}
